import { fromJS, Record } from 'immutable';
import type { AuthState as AuthStateType } from './types.js';

export const AuthState = Record({
  user: null,
  userLoading: false,
  userLoaded: false,
  userCreating: false,
  userCreated: false,
  userUpdating: false,
  userError: null,
  respondToCliError: false,
  cliLoginToken: null,
  accessToken: null
});

const STORAGE_KEY = 'takeshape-user';

export function persistAuthState(authState: AuthStateType) {
  const toPersist = new AuthState().merge({
    user: authState.user,
    userLoaded: authState.userLoaded
  });
  localStorage.setItem(STORAGE_KEY, JSON.stringify(toPersist.toJS()));
}

export function loadAuthState() {
  const json = localStorage.getItem(STORAGE_KEY);
  return new AuthState(json ? fromJS(JSON.parse(json)) : {}) as any as AuthStateType;
}
